import { commentsApi } from "@/config/httpClient"
import { CommentThread, CommentDTO } from "@/generated/openapi"
import { CommentDeleteRespone } from "@/models/CommentDeleteResponse"
import { CommentsCacheForThread } from "@/models/CommentsCacheForThread"
import { Comment } from '@/generated/openapi';

class CommentService {

  private commentsCache: CommentsCacheForThread[] = []

  public getComments(threadId: string, forceReload?: boolean): Promise<CommentThread> {
    if (forceReload) {
      this.removeFromCacheIfCached(threadId)
    }
    return this.getCommentsFromCacheOrLoad(threadId).thread;
  }

  private removeFromCacheIfCached(threadId: string): void {
    for(let i = 0; i < this.commentsCache.length; i++) {
      const x = this.commentsCache[i]
      if (x.threadId === threadId) {
        this.commentsCache.splice(i, 1)
      }
    }
  }

  private getCommentsFromCacheOrLoad(threadId: string): CommentsCacheForThread {
    for(let i = 0; i < this.commentsCache.length; i++) {
      const x = this.commentsCache[i]
      if (x.threadId === threadId) {
        return x;
      }
    }

    const tmpElement:CommentsCacheForThread = {
      threadId: threadId,
      thread: commentsApi.commentsByThread(threadId).then(axiosResponse => {
        return axiosResponse.data
      })
    }
    this.commentsCache.push(tmpElement)
    return tmpElement
  }

  //todo return-type
  public setComment(threadId: string, comment: CommentDTO) {
    return commentsApi.submitComment(threadId, comment)
    .then(resp => resp.data)
  }

  //todo return-type
  private updateComment(threadId: string, commentId: string, comment: CommentDTO){
    return commentsApi.updateComment(threadId, commentId, comment)
    .then(resp => resp.data)
  }

  private deleteComment(threadId: string, commentId: string) {
    return commentsApi.deleteComment(threadId, commentId)
  }

  /**
   * Diese Methode löscht einen Kommentar bzw. markiert einen Kommentar als gelöscht, falls löschen nicht funktioniert, weil bereits Antworten vorhanden sind.
   *
   * @param threadId
   * @param commentId
   */
  public deleteOrMarkDeleted(threadId: string, commentId: string ): Promise<CommentDeleteRespone> {
    const resp = {} as CommentDeleteRespone
    return commentService.getComments(threadId, true).then((commThread) => {
      const commentToDelete = this.findCommentToDelete(commThread, commentId);
      if(commentToDelete !== undefined ) {
        return commentService.deleteComment(threadId, commentId).then(() => {
          resp.success = true
          return resp
        }).catch(() => {
          resp.success = false
          return resp
        })
      } else {
        resp.success = false
        resp.resultReason = "Kommentar ist nicht mehr verfügbar, oder ungültig."
        return Promise.reject(() => resp)
      }
    })
  }

  private findCommentToDelete(thread: CommentThread, commentId: string): Comment | undefined {
    if(thread.comments !== undefined) {
      for(let i = 0; i < thread.comments?.length; i++) {
        const comm = thread.comments[i] as Comment
        if (commentId === comm.id) {
          return thread.comments[i] as Comment
        }
        if (comm.replies !== undefined && comm.replies?.length > 0) {
          for (let j = 0; j < comm.replies.length; j++) {
            if (commentId === comm.replies[j].id) {
              return comm.replies[j] as Comment
            }
          }
        }
      }
    }
    return undefined
  }
}

const commentService = new CommentService()
export default commentService
